export const  getLocalData = (key) =>{
    return window.localStorage.getItem(key);
}

export const  setLocalData = (key,value) =>{
    return window.localStorage.setItem(key,value);
}

